import type { FC } from "react";

import classNames from "classnames";

import { ShoppingBagIcon } from "@jti/brand-icons/shopping-bag";
import { Icon } from "@jti/core-components";
import { useTranslations } from "@jti/ui";
import { HeaderToolsItem } from "@jti/ui/eva-components/MobileFirstHeader/components/HeaderToolsItem";

import styles from "./CartIcon.module.scss";

type CartIconDesktopSize = "sm" | "md";

export type CartIconProps = {
  label?: string | number;
  disabled?: boolean;
  onClick?: () => void;
  isOpen?: boolean;
  isExpanded?: boolean;
  desktopSize?: CartIconDesktopSize;
};

export const CartIcon: FC<CartIconProps> = ({ label, onClick, disabled, isExpanded = false, desktopSize = "md" }) => {
  const { __ } = useTranslations();

  return (
    <HeaderToolsItem
      aria-label={__("cart.cart_mini.title")}
      aria-expanded={isExpanded}
      onClick={onClick}
      data-testid="cartIcon"
      className={classNames({
        [styles.disabled]: disabled,
        [styles.smallOnDesktop]: desktopSize === "sm",
      })}
    >
      <span className={styles.iconWrapper}>
        <span className={styles.mediumIcon}>
          <Icon icon={ShoppingBagIcon} size="md" />
        </span>
        <span className={styles.smallIcon}>
          <Icon icon={ShoppingBagIcon} size="sm" />
        </span>
        {label && <span className={styles.label}>{label}</span>}
      </span>
    </HeaderToolsItem>
  );
};
